import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AdotarChooser from './pages/AdotarChooser';
import AdotarCaes from './pages/AdotarCaes';
import AdotarGatos from './pages/AdotarGatos';
import AdotarDetail from './pages/AdotarDetail';
import Sobre from './pages/Sobre';
import Transparencia from './pages/Transparencia';
import Ajudar from './pages/Ajudar';
import OndeEstamos from './pages/OndeEstamos';
import Contactos from './pages/Contactos';
import './styles/App.css';

const App: React.FC = () => (
  <Router>
    <ScrollToTop />
    <a href="#main" className="psl-skip">Saltar para o conteúdo</a>
    <div className="app">
      <Header />
      <main id="main" className="main-content" tabIndex={-1}>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Literal segments registered first — react-router v7 prefers
              literal over param when both could match. */}
          <Route path="/adotar" element={<AdotarChooser />} />
          <Route path="/adotar/caes" element={<AdotarCaes />} />
          <Route path="/adotar/gatos" element={<AdotarGatos />} />
          <Route path="/adotar/:id" element={<AdotarDetail />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/transparencia" element={<Transparencia />} />
          <Route path="/ajudar" element={<Ajudar />} />
          <Route path="/onde-estamos" element={<OndeEstamos />} />
          <Route path="/contactos" element={<Contactos />} />
        </Routes>
      </main>
      <Footer />
    </div>
  </Router>
);

export default App;
